var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"800px","height":"400px","background-color":"red"}})
}
var staticRenderFns = []

export { render, staticRenderFns }